import { BalloonEventsQuery, ImageSource } from '../types';
import { MultiLanguageTextModel } from './MultiLanguageTextModel';

export class CategoryModel {
  private _id;
  private _slug;
  private _color;
  private _icon;
  private _displayName;
  private _query;
  private _parent;
  private _textIcon;
  private _textIconLiteral;
  private _sortOrder;
  private _isSystem;
  private _children;

  constructor(
    id: string,
    slug: string,
    color: string,
    icon: string,
    displayName: MultiLanguageTextModel,
    query?: BalloonEventsQuery,
    parent: string | null = null,
    textIcon?: string,
    textIconLiteral?: string,
    sortOrder?: number,
    isSystem?: boolean,
    children?: CategoryModel[]
  ) {
    this._id = id;
    this._slug = slug;
    this._color = color;
    this._icon = icon;
    this._displayName = displayName;
    this._query =
      query ||
      ({
        categories: [id],
      } as BalloonEventsQuery);
    if (!this.query.id) {
      this.query.id = id;
    }
    this._parent = parent;
    this._textIcon = textIcon;
    this._textIconLiteral = textIconLiteral;
    this._sortOrder = sortOrder ?? 0;
    this._isSystem = isSystem ?? false;
    this._children = children ?? [];
  }

  public static from(data: CategoryModel): CategoryModel {
    return new CategoryModel(
      data._id,
      data._slug,
      data._color,
      data._icon,
      MultiLanguageTextModel.from(data._displayName),
      data._query,
      data._parent,
      data._textIcon,
      data._textIconLiteral,
      data._sortOrder,
      data._isSystem,
      data._children?.map((c: CategoryModel): CategoryModel => CategoryModel.from(c))
    );
  }

  get placeholderImage(): ImageSource {
    return {
      url: `https://res.balloon-events.com/images/placeholder/${this._slug}.webp`,
    };
  }

  get id() {
    return this._id;
  }

  get slug() {
    return this._slug;
  }

  get displayName() {
    return this._displayName;
  }

  get color() {
    return this._color;
  }

  get icon() {
    return this._icon;
  }

  get query() {
    return this._query;
  }

  get parent() {
    return this._parent;
  }

  get textIcon() {
    return this._textIcon;
  }

  get textIconLiteral() {
    return this._textIconLiteral;
  }

  get sortOrder() {
    return this._sortOrder;
  }

  get isSystem() {
    return this._isSystem;
  }

  get children() {
    return this._children;
  }
}
